import React from "react";
import LoadingScreen from "../../../utils/LoadingScreen";
import { ToastContainer } from "react-toastify";

const AssignToPackky = ({ data = [], loading }) => {
  const twoDecimal = (v) => Number(v || 0).toFixed(2);

  const summary = getPackkySummary(data);

  function getPackkySummary(data) {
    if (!data.length) return null;

    const packkyData = data.filter((item) => {
      return (
        Number(item.message_charges) > 0 ||
        Number(item.delivery_fee) > 0 ||
        Number(item.settlement_amount) !== 0
      );
    });

    if (!packkyData.length) return null;

    let messageCharges = 0;
    let platformCharges = 0;
    let deliveryCharges = 0;
    let netSettlement = 0;

    packkyData.forEach((item) => {
      messageCharges += Number(item.message_charges || 0);
      platformCharges += Number(item.charges || 0);
      deliveryCharges += Number(item.delivery_fee || 0);
      netSettlement += Number(item.settlement_amount || 0);
    });

    const sorted = [...packkyData].sort(
      (a, b) => new Date(a.datetime) - new Date(b.datetime),
    );

    return {
      fromDate: sorted[0]?.datetime,
      toDate: sorted[sorted.length - 1]?.datetime,
      messageCharges,
      platformCharges,
      deliveryCharges,
      netSettlement,
    };
  }

  return (
    <>
      <ToastContainer />
      {/* <div className="p-3 font-semibold border-b montserrat-font-1">Assign To Packky</div> */}

      <div className="max-h-[calc(100vh-230px)] overflow-y-auto overflow-x-auto">
        <table className="w-full text-sm text-start border-separate border-spacing-0">
          <thead className="bg-green-100 sticky top-0 z-20">
            <tr>
              <th className="p-3 bg-green-100">S.No.</th>
              <th className="p-3 bg-green-100">ID</th>
              <th className="p-3 bg-green-100">Customer Mobile</th>
              <th className="p-3 bg-green-100">Date</th>
              <th className="p-3 bg-green-100">Message Charges</th>
              <th className="p-3 bg-green-100">Platform Charges</th>
              <th className="p-3 bg-green-100">Delivery Charges</th>
              <th className="p-3 bg-green-100">Net Settlement</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="text-center py-10">
                  <LoadingScreen text="Loading data..." />
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-6 text-gray-500">
                  No Records Found
                </td>
              </tr>
            ) : (
              data.map((item, i) => (
                <tr key={item.id} className="text-center border-b">
                  <td className="p-2">{i + 1}</td>

                  <td className="p-2 font-semibold">{item.id}</td>

                  <td className="p-2">{item.customer_mobile || "NA"}</td>

                  <td className="p-2">{item.datetime}</td>

                  <td className="p-2">₹ {twoDecimal(item.message_charges)}</td>

                  <td className="p-2">₹ {twoDecimal(item.charges)}</td>

                  <td className="p-2">₹ {twoDecimal(item.delivery_fee)}</td>

                  <td className="p-2 font-semibold">
                    ₹ {twoDecimal(item.settlement_amount)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AssignToPackky;
